<template>
    <div id="container">
        <AppHeader id="header" />
        <div id="content">
            <router-view />
        </div>
        <!--<AdminBreadcrumb id="breadcrumb" />
        <AdminLeftPanel id="leftPanel" />-->
    </div>
</template>

<script>
import AppHeader from '../../components/ui/AppHeader'
/*import AdminBreadcrumb from './AdminBreadcrumb'
import AdminLeftPanel from './AdminLeftPanel'*/

export default {
    components: {
        AppHeader/*,
        AdminBreadcrumb,
        AdminLeftPanel*/
    }
}
</script>

<style scoped>
#container {
    background: #efefef;
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    max-height: 100vh;
}

#header {
    grid-area: header;
    background-color: #ffffff !important;
    border-bottom: 1px solid #dddddd;
    padding: 0px 8px;
    margin-bottom: 8px;
}

#breadcrumb {
    border-bottom: 1px solid #dddddd;
    grid-area: breadcrumb;
    width: 100%;
    max-width: 100%;
    align-self: center;
}

#leftPanel {
    grid-area: leftPanel;
    background-color: #ffffff;
    border-right: 1px solid #dddddd;
}

#content {
    grid-area: content;
    padding: 0px 8px;
    height: 100%;
    overflow: hidden;
}
</style>